import React from 'react';
import dynamic from 'next/dynamic';

// For some reason if we lazy load these components, the context breaks our tests :(
import { AuthProvider } from '@context/auth/base';
import { ConnectedAuthProvider } from '@context/auth/connected';
import { DynamicAuthProvider } from '@context/auth/dynamic';
// -----------------------------

const MediaQuery = dynamic(import('@context/mediaQuery').then(mod => mod.MediaQuery.Provider));
const SecondaryModalContext = dynamic(
  import('@context/secondaryModal').then(mod => mod.SecondaryModalContext.Provider),
);
const SoundStatsigProvider = dynamic(
  import('@context/statsig').then(mod => mod.SoundStatsigProvider),
);
const ToastContext = dynamic(import('@context/toast').then(mod => mod.ToastContext.Provider));
const Transaction = dynamic(import('@context/transaction').then(mod => mod.Transaction.Provider));
const WalletRequest = dynamic(
  import('@context/wallet-request').then(mod => mod.WalletRequest.Provider),
);
const MintReferralContext = dynamic(
  import('@context/mintReferral').then(mod => mod.MintReferralProvider),
);
const ModalContext = dynamic(import('@context/modal').then(mod => mod.ModalContext.Provider));
const ChainProvider = dynamic(import('@context/chainProvider').then(mod => mod.ChainProvider));
const ReservoirProvider = dynamic(
  import('@context/reservoirProvider').then(mod => mod.ReservoirProvider),
);
const DynamicGlobalModal = dynamic(() =>
  import('@components/modals/GlobalModal').then(mod => mod.GlobalModal),
);

const ToastContainer = dynamic(() => import('@context/toast').then(mod => mod.ToastContainer));

const ContextProviders = Object.freeze([
  ReservoirProvider,
  DynamicAuthProvider,
  SoundStatsigProvider,
  MediaQuery,
  WalletRequest,
  SecondaryModalContext,
  MintReferralContext,
  ModalContext,
  ToastContext,
  AuthProvider,
  ChainProvider,
  ConnectedAuthProvider,
  Transaction,
] as const);

export function Provider({ children }: { children: React.ReactNode }) {
  return ContextProviders.reduceRight(
    (acc, Provider) => {
      return <Provider>{acc}</Provider>;
    },
    <>
      <DynamicGlobalModal />
      {children}
      <ToastContainer />
    </>,
  );
}
